/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseCourseidChannelsChannelid200,
  GetApiV1CourseCourseidChannelsChannelid401,
  GetApiV1CourseCourseidChannelsChannelid404,
  GetApiV1CourseCourseidChannelsChannelid500,
  GetApiV1CourseCourseidChannelsChannelidPathParams,
  GetApiV1CourseCourseidChannelsChannelidQueryResponse,
} from "../../types/courseChannelsController/GetApiV1CourseCourseidChannelsChannelid.ts";
import { channelDetailViewModelSchema } from "../channelDetailViewModelSchema.ts";

export const getApiV1CourseCourseidChannelsChannelidPathParamsSchema = z.object(
  {
    courseId: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1CourseCourseidChannelsChannelidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseCourseidChannelsChannelid200Schema = z.lazy(
  () => channelDetailViewModelSchema,
) as unknown as ToZod<GetApiV1CourseCourseidChannelsChannelid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseCourseidChannelsChannelid401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseCourseidChannelsChannelid404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidChannelsChannelid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseCourseidChannelsChannelid500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidChannelsChannelid500>;

export const getApiV1CourseCourseidChannelsChannelidQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseCourseidChannelsChannelid200Schema,
  ) as unknown as ToZod<GetApiV1CourseCourseidChannelsChannelidQueryResponse>;
